import React, { Component } from "react";
import Users from "../../../components/Users/Users";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : UsersForm
Description : Compoente que alberga el resto del formulario de Users definido en el directorio de componentes
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina – Se llama al componente de Users con sus respectivos parámetros.
================================================================================ */

class UsersForm extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <Users/>
        )
    }
}

export default UsersForm;